import Router from 'next/router';
import { setLayout } from './../components/CorporatePage/useCorporateLayout';
export const setImageGrid = (data, isMobile) => {
  let list = [];

  data.forEach(element => {
    let tempCard = {
      img: element.image ? element.image.url : undefined,
      title: element.card_title,
      subtitle: element.card_subtitle,
      onClick:
        element.button_text && element.url_button
          ? () => Router.push(element.url_button)
          : () => {
              console.log('hi');
            },
      buttonText: element.button_text ? element.button_text : '',
      hasButton: element.button_text ? true : false,
      type: setType(element.card_type),
      description: element.card_description ? element.card_description : undefined,
    };
    list.push(tempCard);
  });
  if (isMobile) {
    for (let i = 0; i < list.length; i += 4) {
      if (i + 3 < list.length) {
        [list[i + 2], list[i + 3]] = [list[i + 3], list[i + 2]];
      }
    }
  }
  return list;
};

export const setBlogs = (data, tags, blogs) => {
  let list = [];

  const newData = blogs.map(a2 => data.find(x => x.id === a2.id));

  newData.forEach(element => {
    let tempCard = {
      image: element.content.image?.image ?? undefined,
      title: element.content.title,
      date: new Date(element.updatedAt),
      tag: tags[element.content.category],
      description: element.content.description,
      buttonText: element.content.button_text,
      redirection: element.content.redirection_link,
    };
    list.push(tempCard);
  });

  return list;
};

const setType = i => {
  switch (i) {
    case 0:
      return 'Desc';
    case 1:
      return 'Img';
    case 2:
      return 'Combo';
  }
};

export const setFields = (locale, dropdown_title) => {
  let list = [];
  const data = process.env.contactData[locale];

  data.fields.forEach(el => {
    let temp = {
      type: 'input',
      label: el.title,
      setter: undefined,
      innerType: 'text',
      value: '',
    };
    list.push(temp);
  });
  if (data.options && dropdown_title) {
    const dropdown_options = data.options.map(el => el.title);
    let droptemp = {
      type: 'radioOption',
      label: dropdown_title,
      setter: undefined,
      innerType: 'text',
      value: '',
      selectedIndex: 0,
      options: dropdown_options,
    };
    list.push(droptemp);
  }
  let fields = {
    fields: list,
    comment: '',
  };
  return fields;
};

export const setFaqs = faqs => {
  return faqs.map(el => {
    return {
      question: el.question,
      answer: <div dangerouslySetInnerHTML={{ __html: el.answer }}></div>,
    };
  });
};
